"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslationIndex = void 0;
function getTranslationIndex(languageCode, n) {
    n = Number(n);
    n = typeof n === 'number' && isNaN(n) ? 1 : n;
    if (languageCode && languageCode.length > 2 && languageCode !== 'pt_BR') {
        languageCode = languageCode.split('_')[0];
    }
    switch (languageCode) {
        case 'ay':
        case 'bo':
        case 'cgg':
        case 'dz':
        case 'fa':
        case 'id':
        case 'ja':
        case 'jbo':
        case 'ka':
        case 'kk':
        case 'km':
        case 'ko':
        case 'ky':
        case 'lo':
        case 'ms':
        case 'my':
        case 'sah':
        case 'su':
        case 'th':
        case 'tt':
        case 'ug':
        case 'vi':
        case 'wo':
        case 'zh':
            return 0;
        case 'is':
            return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0;
        case 'jv':
            return n !== 0 ? 1 : 0;
        case 'mk':
            return n === 1 || n % 10 === 1 ? 0 : 1;
        case 'ach':
        case 'ak':
        case 'am':
        case 'arn':
        case 'br':
        case 'fil':
        case 'fr':
        case 'gun':
        case 'ln':
        case 'mfe':
        case 'mg':
        case 'mi':
        case 'oc':
        case 'pt_BR':
        case 'tg':
        case 'ti':
        case 'tr':
        case 'uz':
        case 'wa':
        case 'zh':
            return n > 1 ? 1 : 0;
        case 'lv':
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n !== 0 ? 1 : 2);
        case 'lt':
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        case 'be':
        case 'bs':
        case 'hr':
        case 'ru':
        case 'sr':
        case 'uk':
            return (n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        case 'mnk':
            return (n === 0 ? 0 : n === 1 ? 1 : 2);
        case 'ro':
            return (n === 1 ? 0 : (n === 0 || (n % 100 > 0 && n % 100 < 20)) ? 1 : 2);
        case 'pl':
            return (n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
        case 'cs':
        case 'sk':
            return (n === 1) ? 0 : (n >= 2 && n <= 4) ? 1 : 2;
        case 'csb':
            return (n === 1) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
        case 'sl':
            return (n % 100 === 1 ? 0 : n % 100 === 2 ? 1 : n % 100 === 3 || n % 100 === 4 ? 2 : 3);
        case 'mt':
            return (n === 1 ? 0 : n === 0 || (n % 100 > 1 && n % 100 < 11) ? 1 : (n % 100 > 10 && n % 100 < 20) ? 2 : 3);
        case 'gd':
            return (n === 1 || n === 11) ? 0 : (n === 2 || n === 12) ? 1 : (n > 2 && n < 20) ? 2 : 3;
        case 'cy':
            return (n === 1) ? 0 : (n === 2) ? 1 : (n !== 8 && n !== 11) ? 2 : 3;
        case 'kw':
            return (n === 1) ? 0 : (n === 2) ? 1 : (n === 3) ? 2 : 3;
        case 'ga':
            return n === 1 ? 0 : n === 2 ? 1 : (n > 2 && n < 7) ? 2 : (n > 6 && n < 11) ? 3 : 4;
        case 'ar':
            return (n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
        default:
            return n !== 1 ? 1 : 0;
    }
}
exports.getTranslationIndex = getTranslationIndex;
//# sourceMappingURL=plurals.js.map